import React, { useEffect, useRef, useState } from "react";

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export function LazyRender({ children, fallback = null }: Props) {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
          observer.disconnect(); // Stop observing once loaded
        }
      },
      {
        rootMargin: "200px 0px", // Trigger slightly before scrolling into view for smoother UX
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      {isIntersecting ? children : fallback}
    </div>
  );
}

export default LazyRender;
